import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  Toolbar,
  Hidden,
  makeStyles,
  SvgIcon,
  IconButton,
} from '@material-ui/core';
import Logo from 'src/components/Logo';
import { THEMES } from 'src/constants';
import Account from './Account';
import Settings from './Settings';
import { Menu as MenuIcon } from 'react-feather';

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    ...(theme.name === THEMES.LIGHT
      ? {
          boxShadow: 'none',
          backgroundColor: theme.palette.primary.main,
        }
      : {}),
    ...(theme.name === THEMES.ONE_DARK
      ? {
          backgroundColor: theme.palette.background.default,
        }
      : {}),
  },
  toolbar: {
    minHeight: 54,
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: 20,
  },
  righttoolbar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

function TopBar({ className, onMobileNavOpen, ...rest }) {
  const classes = useStyles();

  return (
    <AppBar className={clsx(classes.root, className)} {...rest}>
      <Toolbar className={classes.toolbar}>
        <div
          style={{
            display: 'flex',
            alignContent: 'flex-start',
            width: 240,
          }}
        >
          <Hidden lgUp>
            <IconButton
              className={classes.menuButton}
              color='inherit'
              onClick={onMobileNavOpen}
            >
              <SvgIcon fontSize='small'>
                <MenuIcon />
              </SvgIcon>
            </IconButton>
          </Hidden>
          <Hidden mdDown>
            <RouterLink to='/'>
              <Logo />
            </RouterLink>
          </Hidden>
        </div>
        <div className={classes.righttoolbar}>
          <Box ml={2} flexGrow={1} />
          {/* <Notifications />
          <Settings /> */}
          <Box ml={2}>
            <Account />
          </Box>
        </div>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

export default TopBar;
